import { createTypes } from "@/store/utils";

export const FETCH_LETTERS_TEMPLATES_LIST = createTypes(
  "FETCH_LETTERS_TEMPLATES_LIST"
);
export const CREATE_LETTER_TEMPLATE = createTypes("CREATE_LETTER_TEMPLATE");
export const DELETE_LETTER_TEMPLATE = createTypes("DELETE_LETTER_TEMPLATE");
export const UPDATE_LETTER_TEMPLATE = createTypes("UPDATE_LETTER_TEMPLATE");
export const RETRIEVE_LETTER_TEMPLATE = createTypes("RETRIEVE_LETTER_TEMPLATE");
export const UPDATE_THUMBNAIL = createTypes("UPDATE_THUMBNAIL");
export const FETCH_PRODUCT_CODES_LIST = createTypes("FETCH_PRODUCT_CODES_LIST");
